import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';
import { saveAs } from 'file-saver';

@Injectable({ providedIn: 'root' })
export class CompanyManageService {
    companies: any[];
    onCompaniesChanged: BehaviorSubject<any>;
    constructor(private httpClient: HttpClient) {
        this.companies = [];
        this.onCompaniesChanged = new BehaviorSubject<any>([]);
    }

    getCompanies() {
        return new Promise((resolve, reject) => {
            this.httpClient
                .get(environment.apiEndpoint + 'administrator/companies')
                .subscribe((res) => {
                    this.companies = res as any[];
                    this.onCompaniesChanged.next(this.companies);
                    resolve(res);
                }, reject);
        });
    }

    approveCompany(id) {
        return this.httpClient.post(
            `${environment.apiEndpoint}administrator/companies/${id}/approve`,
            {}
        );
    }

    downloadCompanyPoster(id, companyName) {
        return new Observable<any>((subscription) => {
            this.httpClient
                .get(`${environment.apiEndpoint}administrator/companies/${id}/download-info`, {
                    responseType: 'arraybuffer',
                })
                .subscribe(
                    (response) => {
                        const blob = new Blob([response], {
                            type: 'application/zip',
                        });
                        const safeCompanyName = companyName ? companyName.replace(/[<>:"/\\|?*\x00-\x1F]/g, '_') : 'company';
                        saveAs(blob, id + '_' + safeCompanyName + '.zip');
                        subscription.next(response);
                    },
                    (err) => {
                        console.log('Error while downloading image:', err);
                    }
                );
        });
    }
}
